module.exports = __webpack_public_path__ + "media/images/covid/icons/handS-10397f0326c4c3b0589f975d395c6de4.png";